import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import Vuelidate from 'vuelidate'
import SvgIcon from "./elements/SvgIcon";
import Axios from 'axios';
import 'mapbox-gl/dist/mapbox-gl.css';

Axios.defaults.headers.common = {
    accept: 'application/json',
    'Accept-Language': i18n.locale,
    'content-type': 'application/json'
};
import VueJWT from 'vuejs-jwt'

Vue.use(VueJWT)

import "@/assets/sass/_common.sass"
import alerts from '@/elements/alerts.vue';
import logo from '@/elements/logo.vue';
import ModalActions from '@/elements/Modals/ModalActions';
import ModalInfo from '@/elements/Modals/ModalInfo';
import BackButton from "@/elements/BackButton";
Vue.use(Vuelidate);
Vue.component('alerts', alerts);
Vue.component('logo', logo);
Vue.component('svg-icon', SvgIcon);
Vue.component('ModalActions', ModalActions);
Vue.component('ModalInfo', ModalInfo);
Vue.component('BackButton', BackButton);

import Rollbar from 'rollbar';
Vue.prototype.$rollbar = new Rollbar({
    accessToken: '5bb6c7be14684346b0a0ec5836642bb6',
    captureUncaught: true,
    enabled: process.env.NODE_ENV !== 'local',
    captureUnhandledRejections: true,
    payload: {
        environment: process.env.NODE_ENV
    }
});
Vue.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
};

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
